import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  caseStudyList: [],
};

export const featuredCaseExamplesSlice = createSlice({
  name: "featuredCaseExamples",
  initialState,
  reducers: {
    featuredCaseExamplesStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    featuredCaseExamplesSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      caseStudyList: action.payload,
    }),
    featuredCaseExamplesFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    resetFeaturedCaseExamples: () => ({
      ...initialState,
    })
  },
});

export const { 
  featuredCaseExamplesStart,
  featuredCaseExamplesSuccess,
  featuredCaseExamplesFailure,
  resetFeaturedCaseExamples,
} = featuredCaseExamplesSlice.actions;

export const getFeaturedCaseExamples= () => (dispatch) => {
  dispatch(featuredCaseExamplesStart());
  const apiPath = Constants.API.HOME_PAGE + Constants.API.FEATURED_CASE_EXAMPLES;
  apiService.get(apiPath).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(featuredCaseExamplesSuccess(data?.data));
      } else {
        dispatch(featuredCaseExamplesFailure());
      }
    } else {
      dispatch(featuredCaseExamplesFailure());
    }
  }).catch(() => {
    dispatch(featuredCaseExamplesFailure());
  })
};

export default featuredCaseExamplesSlice.reducer;
